import React from 'react'
import './sectionHeader.scss'

const SectionHeader = ({
	titleHeadingLevel,
	titleHeadingSize,
	supTitleType,
	theme,
	titleIcon,
	supTitle,
	title,
	titleCustomClass,
	subTitle,
	subTitleCustomClass,
	supTitleCustomClass,
	children,
}) => {
	let Heading =
		titleHeadingLevel === undefined
			? `h${titleHeadingSize}`
			: `h${titleHeadingLevel}`
	let SupTitleType = supTitleType ? supTitleType : 'span'

	return (
		<header
			className={`section_header${
				theme !== undefined ? ` section-${theme}` : ''
			}`}
		>
			<div className="section_headerInner">
				{titleIcon !== undefined && (
					<div className="section_titleIcon">{titleIcon}</div>
				)}

				{supTitle !== undefined && (
					<SupTitleType
						className={`section_supTitle ${supTitleCustomClass ?? ''}`}
					>
						{supTitle}
					</SupTitleType>
				)}

				{title !== undefined && (
					<Heading
						className={`section_title section_title-${titleHeadingSize} ${
							titleCustomClass ?? ''
						}`}
					>
						{title}
					</Heading>
				)}

				{subTitle !== undefined && (
					<p className={`section_subTitle ${subTitleCustomClass ?? ''}`}>
						{subTitle}
					</p>
				)}
				{children}
			</div>
		</header>
	)
}

export default SectionHeader
